import React from 'react';
import '../styles/Summary.scss';

function Summary() {
  return (
    <div className='summary container'>
    <p className='summaryTitle'>House Cleaning Services in Delhi NCR :</p>
    <p className='summaryBody'> Get home cleaning services in Delhi NCR, India. We have Well Equipped and Trained Team, who carries out Deep House Cleaning and Sanitization with Non-Hazardous Chemicals. Book well-trained and experienced team from OyeBusy to get your home deep cleaned thoroughly at your chosen time and location. We offer the most affordable home cleaning services in Delhi NCR, India for studios, apartments, and villas. Book home cleaning services on OyeBusy today.</p>
    </div>
    )
}

export default Summary